import { render, staticRenderFns } from "./TopServicesReport.vue?vue&type=template&id=8642f6ae&scoped=true&"
import script from "./TopServicesReport.vue?vue&type=script&lang=js&"
export * from "./TopServicesReport.vue?vue&type=script&lang=js&"
import style0 from "./TopServicesReport.vue?vue&type=style&index=0&id=8642f6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8642f6ae",
  null
  
)

export default component.exports